/*
 * @Description:工业-终端支付管理
 * @Date: 2025-10-11 10:36:04
 */
import http from '@/utils/http/axios';
import { terminalPayMgrList } from './types';
enum Api {
  terminalPayMgrList = '/front-end/industry-terminal-payment/list', //终端支付管理列表
  terminalPaySelectList = '/front-end/industry-terminal-payment/querySelectList', //终端支付查询条件下拉列表
  terminalpeopleList = '/front-end/industry-terminal-payment/peopleList', //终端支付项目结算人员列表

  batchDownload = '/front-end/industry-receipt-download/batchDownload', // 批量下载回单
  export = '/front-end/industry-terminal-payment-export/export' // 导出
}
export const exportTerminalPayListUrl = params =>
  http.download(
    {
      url: Api.export,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: true
    }
  );
export const batchDownloadReceipt = async (params: {
  fileName: string; //文件名称
  downloadType: number;
  //下载业务类型：参考枚举AspDownloadEnum
  //   801 - 工业-终端支付管理-批量下载回单
  downloadList?: {
    id: number;
    aspOrderId: number;
    aspSupplierOrderId: number;
    orderType: number;
  }[]; //业务数据ID集合
  queryParam?: string; //查询条件(JSON格式字符串)
}) =>
  http.request(
    {
      url: Api.batchDownload,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: true
    }
  );
export const terminalPayList: terminalPayMgrList = async function (params) {
  const resp = await http.request(
    {
      url: Api.terminalPayMgrList,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
  );
  return resp;
};

export const terminalpList = async function (params: {
  orderId: number;
  pageNo: number;
  pageSize: number;
  fullName: string;
  phone: string;
}) {
  const resp = await http.request(
    {
      url: Api.terminalpeopleList,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
  );
  return resp;
};

export const terminalquerySelectList = async function (params: {
  type: number;
  keyword: string;
}) {
  const resp = await http.request({
    url: Api.terminalPaySelectList,
    method: 'POST',
    params
  });
  return resp;
};
